const config = {
  BASE_URL: process.env.VUE_APP_API_URL || "https://devbackend.goldenkey.co.mz/api",
};

export default config;
